{
  "v": "5.9.4",
  "fr": 24,
  "ip": 0,
  "op": 96,
  "w": 500,
  "h": 500,
  "nm": "Ziro-Management_Icon",
  "ddd": 0,
  "assets": [],
  "layers": [
    {
      "ddd": 0,
      "ind": 1,
      "ty": 4,
      "nm": "Pencil",
      "parent": 2,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": {
          "a": 1,
          "k": [
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.333], "y": [0] }, "t": 0, "s": [45] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 5, "s": [90.468] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 10, "s": [24.213] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 13, "s": [39.169] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 16, "s": [49.683] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 19, "s": [31.114] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 22, "s": [21.542] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 26, "s": [-2.528] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 29, "s": [24.874] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 32, "s": [-4.582] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 36, "s": [17.24] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 40, "s": [43.165] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 44, "s": [20.149] },
            { "i": { "x": [0.833], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 47, "s": [26.599] },
            { "i": { "x": [0.667], "y": [1] }, "o": { "x": [0.167], "y": [0] }, "t": 51, "s": [-13.149] },
            { "t": 59, "s": [45] }
          ],
          "ix": 10
        },
        "p": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.562, "y": 1 },
              "o": { "x": 0.702, "y": 0 },
              "t": 0,
              "s": [-7.245, 6.769, 0],
              "to": [-5, -7.417, 0],
              "ti": [7.45, 4.867, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 10,
              "s": [-9.845, -18.731, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.504, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 13,
              "s": [-9.845, -18.731, 0],
              "to": [-0.85, 4.833, 0],
              "ti": [2.1, -5.883, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 19,
              "s": [-18.145, -10.331, 0],
              "to": [0.1, 0.133, 0],
              "ti": [0.083, 0, 0]
            },
            {
              "i": { "x": 0.464, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 22,
              "s": [-18.145, -10.331, 0],
              "to": [-0.683, -3.35, 0],
              "ti": [1.483, 3.2, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 27,
              "s": [-18.945, -19.031, 0],
              "to": [0.067, -0.05, 0],
              "ti": [0.092, -0.067, 0]
            },
            {
              "i": { "x": 0.464, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 30,
              "s": [-18.945, -19.031, 0],
              "to": [-0.342, 3.567, 0],
              "ti": [-0.539, -3.116, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 35,
              "s": [-13.995, -10.531, 0],
              "to": [0.089, 0.066, 0],
              "ti": [-0.08, -0.045, 0]
            },
            {
              "i": { "x": 0.464, "y": 1 },
              "o": { "x": 0.333, "y": 0 },
              "t": 38,
              "s": [-13.945, -10.531, 0],
              "to": [-1.415, -0.293, 0],
              "ti": [1.178, 0.805, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 43,
              "s": [-18.515, -14.56, 0],
              "to": [-0.028, -0.005, 0],
              "ti": [0.024, 0.034, 0]
            },
            {
              "i": { "x": 0.384, "y": 1 },
              "o": { "x": 0.89, "y": 0 },
              "t": 46,
              "s": [-18.515, -14.56, 0],
              "to": [1.513, -1.447, 0],
              "ti": [4.418, -9.918, 0]
            },
            { "t": 57, "s": [-7.245, 6.769, 0] }
          ],
          "ix": 2,
          "l": 2
        },
        "a": {
          "a": 1,
          "k": [
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.333, "y": 0 },
              "t": 9,
              "s": [18.05, 24.231, 0],
              "to": [0, -0.233, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 11,
              "s": [18.05, 22.831, 0],
              "to": [0, 0, 0],
              "ti": [0, -0.233, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 14,
              "s": [18.05, 24.231, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.333, "y": 0 },
              "t": 18,
              "s": [18.05, 24.231, 0],
              "to": [0, -0.233, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 20,
              "s": [18.05, 22.831, 0],
              "to": [0, 0, 0],
              "ti": [0, -0.233, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 23,
              "s": [18.05, 24.231, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.333, "y": 0 },
              "t": 26,
              "s": [18.05, 24.231, 0],
              "to": [0, -0.233, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 28,
              "s": [18.05, 22.831, 0],
              "to": [0, 0, 0],
              "ti": [0, -0.233, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 31,
              "s": [18.05, 24.231, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.333, "y": 0 },
              "t": 34,
              "s": [18.05, 24.231, 0],
              "to": [0, -0.233, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 36,
              "s": [18.05, 22.831, 0],
              "to": [0, 0, 0],
              "ti": [0, -0.233, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 39,
              "s": [18.05, 24.231, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.333, "y": 0 },
              "t": 42,
              "s": [18.05, 24.231, 0],
              "to": [0, -0.233, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 44,
              "s": [18.05, 22.831, 0],
              "to": [0, 0, 0],
              "ti": [0, -0.233, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 47,
              "s": [18.05, 24.231, 0],
              "to": [0, 0, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.833, "y": 0.833 },
              "o": { "x": 0.333, "y": 0 },
              "t": 49,
              "s": [18.05, 24.231, 0],
              "to": [0, -0.233, 0],
              "ti": [0, 0, 0]
            },
            {
              "i": { "x": 0.667, "y": 1 },
              "o": { "x": 0.167, "y": 0.167 },
              "t": 51,
              "s": [18.05, 22.831, 0],
              "to": [0, 0, 0],
              "ti": [0, -0.233, 0]
            },
            { "t": 54, "s": [18.05, 24.231, 0] }
          ],
          "ix": 1,
          "l": 2
        },
        "s": { "a": 0, "k": [91.787, 91.787, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [16.565, 21.028],
                    [18.05, 23.22],
                    [19.535, 21.028],
                    [19.535, 4.906],
                    [16.424, 5.048]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [-0.424, 0],
                    [0, 0],
                    [0, -0.424],
                    [0, 0],
                    [0.071, -0.071],
                    [0, 0],
                    [0.283, 0],
                    [0.071, 0.212],
                    [0, 0],
                    [0, 0.141]
                  ],
                  "o": [
                    [0, -0.424],
                    [0, 0],
                    [0.424, 0],
                    [0, 0],
                    [0, 0.141],
                    [0, 0],
                    [-0.141, 0.283],
                    [-0.283, 0],
                    [0, 0],
                    [-0.141, -0.141],
                    [0, 0]
                  ],
                  "v": [
                    [14.939, 4.128],
                    [15.717, 3.351],
                    [20.242, 3.351],
                    [21.02, 4.128],
                    [21.161, 21.24],
                    [21.02, 21.665],
                    [18.757, 25.059],
                    [18.121, 25.412],
                    [17.484, 25.059],
                    [15.222, 21.665],
                    [15.08, 21.24]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.043121337891, 0.145080566406, 0.152923583984, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0],
                    [0, 0]
                  ],
                  "v": [
                    [15.768, 21.63],
                    [18.09, 24.012],
                    [20.412, 21.63],
                    [20.412, 4.114],
                    [15.547, 4.268]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0.243133544922, 0.7568359375, 0.803894042969, 1], "h": 1 },
                  { "t": 7, "s": [1, 1, 1, 1], "h": 1 },
                  { "t": 54, "s": [0.243133544922, 0.7568359375, 0.803894042969, 1], "h": 1 }
                ],
                "ix": 4
              },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "BG",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 2,
      "ty": 4,
      "nm": "Circle",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [272.703, 263.652, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": {
          "a": 1,
          "k": [
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.413, 0.413, 0.333], "y": [0, 0, 0] },
              "t": 57,
              "s": [100, 100, 100]
            },
            {
              "i": { "x": [0.667, 0.667, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.209, 0.209, 0.333], "y": [0, 0, 0] },
              "t": 62,
              "s": [95, 95, 100]
            },
            {
              "i": { "x": [0.419, 0.419, 0.667], "y": [1, 1, 1] },
              "o": { "x": [0.333, 0.333, 0.333], "y": [0, 0, 0] },
              "t": 72,
              "s": [103, 103, 100]
            },
            { "t": 84, "s": [100, 100, 100] }
          ],
          "ix": 6,
          "l": 2
        }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-8.174, 0],
                    [0, -8.174],
                    [8.174, 0],
                    [0, 8.174]
                  ],
                  "o": [
                    [8.174, 0],
                    [0, 8.174],
                    [-8.174, 0],
                    [0, -8.174]
                  ],
                  "v": [
                    [0, -14.8],
                    [14.8, 0],
                    [0, 14.8],
                    [-14.8, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": {
                "a": 1,
                "k": [
                  {
                    "i": { "x": [0.833, 0.833], "y": [0.833, 0.833] },
                    "o": { "x": [0.8, 0.8], "y": [0, 0] },
                    "t": 4,
                    "s": [100, 100]
                  },
                  {
                    "i": { "x": [0.833, 0.833], "y": [0.833, 0.833] },
                    "o": { "x": [0.167, 0.167], "y": [0.167, 0.167] },
                    "t": 8,
                    "s": [0, 0]
                  },
                  {
                    "i": { "x": [0.2, 0.2], "y": [1, 1] },
                    "o": { "x": [0.167, 0.167], "y": [0.167, 0.167] },
                    "t": 52,
                    "s": [0, 0]
                  },
                  { "t": 56, "s": [100, 100] }
                ],
                "ix": 3
              },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 3,
      "ty": 4,
      "nm": "Phone",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [236.148, 240.449, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [236.148, 240.449, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [12.855, 36.358], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 2, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [236.148, 240.449], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Phone",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 4,
      "ty": 4,
      "nm": "Phone Body",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [240.136, 225.391, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [-11.5, 0.55],
                    [-10.7, 1.35],
                    [-11.5, 2.15],
                    [-12.3, 1.35]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 3",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 1,
              "ty": "sh",
              "ix": 2,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [-11.5, -2.95],
                    [-10.7, -2.15],
                    [-11.5, -1.35],
                    [-12.3, -2.15]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 4",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 2,
              "ty": "sh",
              "ix": 3,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [11.6, 0.55],
                    [12.4, 1.35],
                    [11.6, 2.15],
                    [10.8, 1.35]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 5",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 3,
              "ty": "sh",
              "ix": 4,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-0.442, 0],
                    [0, -0.442],
                    [0.442, 0],
                    [0, 0.442]
                  ],
                  "o": [
                    [0.442, 0],
                    [0, 0.442],
                    [-0.442, 0],
                    [0, -0.442]
                  ],
                  "v": [
                    [11.6, -2.95],
                    [12.4, -2.15],
                    [11.6, -1.35],
                    [10.8, -2.15]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 6",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 4,
              "ty": "sh",
              "ix": 5,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [0, 0],
                    [0, -0.3],
                    [0, 0],
                    [-0.3, 0],
                    [0, 0],
                    [0, 0.3],
                    [0, 0],
                    [0.3, 0]
                  ],
                  "o": [
                    [-0.3, 0],
                    [0, 0],
                    [0, 0.3],
                    [0, 0],
                    [0.3, 0],
                    [0, 0],
                    [0, -0.3],
                    [0, 0]
                  ],
                  "v": [
                    [-7.7, -3.05],
                    [-8.3, -2.45],
                    [-8.3, 2.45],
                    [-7.7, 3.05],
                    [7.7, 3.05],
                    [8.3, 2.45],
                    [8.3, -2.45],
                    [7.7, -3.05]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ind": 5,
              "ty": "sh",
              "ix": 6,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [1, 0],
                    [0, 0],
                    [0, 1.1],
                    [0, 0],
                    [-1.1, 0],
                    [0, 0],
                    [0, -1.1],
                    [0, 0]
                  ],
                  "o": [
                    [0, 0],
                    [-1, 0],
                    [0, 0],
                    [0, -1],
                    [0, 0],
                    [1, 0],
                    [0, 0],
                    [0, 1]
                  ],
                  "v": [
                    [7.7, 4.35],
                    [-7.7, 4.35],
                    [-9.6, 2.45],
                    [-9.6, -2.45],
                    [-7.7, -4.35],
                    [7.7, -4.35],
                    [9.6, -2.45],
                    [9.6, 2.45]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 2",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [257.75, 235.7], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Screen",
          "np": 7,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.2]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.71, 255.7], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 1",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 1,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.71, 251.8], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 2",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 2,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0.3]
                      ],
                      "v": [
                        [1, 0.5],
                        [-1, 0.5],
                        [-1.5, 0],
                        [-1, -0.5],
                        [1, -0.5],
                        [1.5, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.7, 248], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 3",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 3,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [268.71, 244.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 4",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 4,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.2]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.81, 255.7], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 5",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 5,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.81, 251.8], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 6",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 6,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0.3]
                      ],
                      "v": [
                        [1, 0.5],
                        [-1, 0.5],
                        [-1.5, 0],
                        [-1, -0.5],
                        [1, -0.5],
                        [1.5, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.8, 248], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 7",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 7,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0.1, 0.3]
                      ],
                      "v": [
                        [0.99, 0.5],
                        [-1.01, 0.5],
                        [-1.51, 0],
                        [-1.01, -0.5],
                        [0.99, -0.5],
                        [1.49, 0]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [247.81, 244.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 8",
              "np": 2,
              "cix": 2,
              "bm": 0,
              "ix": 8,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.05, -2.7],
                        [-2.65, -2.7],
                        [-2.65, -5.7],
                        [-6.05, -5.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.35, -2.3],
                        [-6.35, -2.3],
                        [-6.35, -6],
                        [-2.35, -6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.55, -2.7],
                        [1.45, -2.7],
                        [1.45, -5.7],
                        [-1.55, -5.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.85, -2.3],
                        [-1.85, -2.3],
                        [-1.85, -6],
                        [1.85, -6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.65, -2.7],
                        [6.05, -2.7],
                        [6.05, -5.7],
                        [2.65, -5.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.35, -2.3],
                        [2.35, -2.3],
                        [2.35, -6],
                        [6.35, -6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.05, 1.5],
                        [-2.65, 1.5],
                        [-2.65, -1.5],
                        [-6.05, -1.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.35, 1.8],
                        [-6.35, 1.8],
                        [-6.35, -1.9],
                        [-2.35, -1.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.55, 1.5],
                        [1.45, 1.5],
                        [1.45, -1.5],
                        [-1.55, -1.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.85, 1.8],
                        [-1.85, 1.8],
                        [-1.85, -1.9],
                        [1.85, -1.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 10,
                  "ty": "sh",
                  "ix": 11,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.65, 1.5],
                        [6.05, 1.5],
                        [6.05, -1.5],
                        [2.65, -1.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 11",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 11,
                  "ty": "sh",
                  "ix": 12,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.35, 1.8],
                        [2.35, 1.8],
                        [2.35, -1.9],
                        [6.35, -1.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 12",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 12,
                  "ty": "sh",
                  "ix": 13,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.05, 5.7],
                        [-2.65, 5.7],
                        [-2.65, 2.7],
                        [-6.05, 2.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 13",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 13,
                  "ty": "sh",
                  "ix": 14,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.35, 6],
                        [-6.35, 6],
                        [-6.35, 2.3],
                        [-2.35, 2.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 14",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 14,
                  "ty": "sh",
                  "ix": 15,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.55, 5.7],
                        [1.45, 5.7],
                        [1.45, 2.7],
                        [-1.55, 2.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 15",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 15,
                  "ty": "sh",
                  "ix": 16,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.85, 6],
                        [-1.85, 6],
                        [-1.85, 2.3],
                        [1.85, 2.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 16",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 16,
                  "ty": "sh",
                  "ix": 17,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.65, 5.7],
                        [6.05, 5.7],
                        [6.05, 2.7],
                        [2.65, 2.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 17",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 17,
                  "ty": "sh",
                  "ix": 18,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.35, 6],
                        [2.35, 6],
                        [2.35, 2.3],
                        [6.35, 2.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 18",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 18,
                  "ty": "sh",
                  "ix": 19,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, -0.2],
                        [0, 0],
                        [-0.2, 0],
                        [0, 0],
                        [0, 0.2],
                        [0, 0],
                        [0.2, 0],
                        [0, 0]
                      ],
                      "o": [
                        [-0.1, 0],
                        [0, 0],
                        [0, 0.1],
                        [0, 0],
                        [0.1, 0],
                        [0, 0],
                        [0, -0.1],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.65, -6.5],
                        [-6.95, -6.2],
                        [-6.95, 6.4],
                        [-6.65, 6.7],
                        [6.65, 6.7],
                        [6.95, 6.4],
                        [6.95, -6.3],
                        [6.65, -6.6],
                        [-6.65, -6.6]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 19",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 19,
                  "ty": "sh",
                  "ix": 20,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3],
                        [0, 0],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-0.3, 0],
                        [0, 0],
                        [0, -0.3],
                        [0, 0],
                        [0.3, 0],
                        [0, 0],
                        [0, 0.3]
                      ],
                      "v": [
                        [6.65, 6.9],
                        [-6.65, 6.9],
                        [-7.25, 6.3],
                        [-7.25, -6.3],
                        [-6.65, -6.9],
                        [6.65, -6.9],
                        [7.25, -6.3],
                        [7.25, 6.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 20",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 9",
              "np": 21,
              "cix": 2,
              "bm": 0,
              "ix": 9,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "gr",
              "it": [
                {
                  "ind": 0,
                  "ty": "sh",
                  "ix": 1,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.55, 5.9],
                        [2.55, 2.6],
                        [6.25, 2.6],
                        [6.25, 5.9]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 1",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 1,
                  "ty": "sh",
                  "ix": 2,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.25, 2.5],
                        [-2.55, 2.5],
                        [-2.55, 5.8],
                        [-6.25, 5.8]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 2",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 2,
                  "ty": "sh",
                  "ix": 3,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-2.55, -5.8],
                        [-2.55, -2.5],
                        [-6.25, -2.5],
                        [-6.25, -5.8]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 3",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 3,
                  "ty": "sh",
                  "ix": 4,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [6.25, -2.5],
                        [2.55, -2.5],
                        [2.55, -5.8],
                        [6.25, -5.8]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 4",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 4,
                  "ty": "sh",
                  "ix": 5,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [2.55, -1.6],
                        [6.25, -1.6],
                        [6.25, 1.7],
                        [2.55, 1.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 5",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 5,
                  "ty": "sh",
                  "ix": 6,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.65, -2.5],
                        [-1.65, -5.8],
                        [1.65, -5.8],
                        [1.65, -2.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 6",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 6,
                  "ty": "sh",
                  "ix": 7,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-6.25, -1.6],
                        [-2.55, -1.6],
                        [-2.55, 1.7],
                        [-6.25, 1.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 7",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 7,
                  "ty": "sh",
                  "ix": 8,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [1.65, 2.5],
                        [1.65, 5.8],
                        [-1.65, 5.8],
                        [-1.65, 2.5]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 8",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 8,
                  "ty": "sh",
                  "ix": 9,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [0, 0],
                        [0, 0],
                        [0, 0]
                      ],
                      "v": [
                        [-1.65, 1.7],
                        [-1.65, -1.6],
                        [1.65, -1.6],
                        [1.65, 1.7]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 9",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ind": 9,
                  "ty": "sh",
                  "ix": 10,
                  "ks": {
                    "a": 0,
                    "k": {
                      "i": [
                        [0.2, 0],
                        [0, 0],
                        [0, -0.2],
                        [0, 0],
                        [-0.2, 0],
                        [0, 0],
                        [0, 0.2],
                        [0, 0]
                      ],
                      "o": [
                        [0, 0],
                        [-0.2, 0],
                        [0, 0],
                        [0, 0.2],
                        [0, 0],
                        [0.2, 0],
                        [0, 0],
                        [0, -0.2]
                      ],
                      "v": [
                        [6.65, -6.7],
                        [-6.65, -6.7],
                        [-7.05, -6.3],
                        [-7.05, 6.3],
                        [-6.65, 6.7],
                        [6.65, 6.7],
                        [7.05, 6.3],
                        [7.05, -6.3]
                      ],
                      "c": true
                    },
                    "ix": 2
                  },
                  "nm": "Path 10",
                  "mn": "ADBE Vector Shape - Group",
                  "hd": false
                },
                {
                  "ty": "fl",
                  "c": { "a": 0, "k": [0.243137255311, 0.75686275959, 0.803921580315, 1], "ix": 4 },
                  "o": { "a": 0, "k": 100, "ix": 5 },
                  "r": 1,
                  "bm": 0,
                  "nm": "Fill 1",
                  "mn": "ADBE Vector Graphic - Fill",
                  "hd": false
                },
                {
                  "ty": "tr",
                  "p": { "a": 0, "k": [258.35, 250.2], "ix": 2 },
                  "a": { "a": 0, "k": [0, 0], "ix": 1 },
                  "s": { "a": 0, "k": [100, 100], "ix": 3 },
                  "r": { "a": 0, "k": 0, "ix": 6 },
                  "o": { "a": 0, "k": 100, "ix": 7 },
                  "sk": { "a": 0, "k": 0, "ix": 4 },
                  "sa": { "a": 0, "k": 0, "ix": 5 },
                  "nm": "Transform"
                }
              ],
              "nm": "Group 10",
              "np": 11,
              "cix": 2,
              "bm": 0,
              "ix": 10,
              "mn": "ADBE Vector Group",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [268.21, 244.7], "ix": 2 },
              "a": { "a": 0, "k": [268.71, 244.2], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Buttons",
          "np": 10,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 3, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "st",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 3 },
              "o": { "a": 0, "k": 100, "ix": 4 },
              "w": { "a": 0, "k": 2, "ix": 5 },
              "lc": 1,
              "lj": 1,
              "ml": 4,
              "bm": 0,
              "nm": "Stroke 1",
              "mn": "ADBE Vector Graphic - Stroke",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "BG",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 5,
      "ty": 4,
      "nm": "Buttons",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [253.542, 246.464, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [25.095, 16.96, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [20, 20, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 28, "s": [100], "h": 1 },
                  { "t": 31, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [25.22, 16.96], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "1",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 0, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [46.709, 16.96], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "2",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 2,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 12, "s": [100], "h": 1 },
                  { "t": 15, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.686, 16.96], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "3",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 44, "s": [100], "h": 1 },
                  { "t": 47, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [25.22, 38.531], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.956, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "4",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 4,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 0, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [46.709, 38.531], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "5",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 5,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 0, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.686, 38.531], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "6",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 6,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 20, "s": [100], "h": 1 },
                  { "t": 23, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [25.22, 59.414], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.956, 93.085], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "7",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 7,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": {
                "a": 1,
                "k": [
                  { "t": 0, "s": [0], "h": 1 },
                  { "t": 36, "s": [100], "h": 1 },
                  { "t": 39, "s": [0], "h": 1 }
                ],
                "ix": 5
              },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [46.709, 59.414], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "8",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 8,
          "mn": "ADBE Vector Group",
          "hd": false
        },
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [22.69, 20.921], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.243133544922, 0.7568359375, 0.803894042969, 1], "ix": 4 },
              "o": { "a": 0, "k": 0, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [67.686, 59.414], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [92.443, 93.085], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "9",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 9,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 6,
      "ty": 4,
      "nm": "Phone BG",
      "parent": 4,
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [248.55, 243.15, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [248.55, 243.15, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [100, 100, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ty": "rc",
              "d": 1,
              "s": { "a": 0, "k": [48.926, 36.963], "ix": 2 },
              "p": { "a": 0, "k": [0, 0], "ix": 3 },
              "r": { "a": 0, "k": 3, "ix": 4 },
              "nm": "Rectangle Path 1",
              "mn": "ADBE Vector Shape - Rect",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [1, 1, 1, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [248.483, 245.352], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "BG",
          "np": 3,
          "cix": 2,
          "bm": 0,
          "ix": 3,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    },
    {
      "ddd": 0,
      "ind": 7,
      "ty": 4,
      "nm": "BG",
      "sr": 1,
      "ks": {
        "o": { "a": 0, "k": 100, "ix": 11 },
        "r": { "a": 0, "k": 0, "ix": 10 },
        "p": { "a": 0, "k": [249.8, 249.9, 0], "ix": 2, "l": 2 },
        "a": { "a": 0, "k": [0, 0, 0], "ix": 1, "l": 2 },
        "s": { "a": 0, "k": [500, 500, 100], "ix": 6, "l": 2 }
      },
      "ao": 0,
      "shapes": [
        {
          "ty": "gr",
          "it": [
            {
              "ind": 0,
              "ty": "sh",
              "ix": 1,
              "ks": {
                "a": 0,
                "k": {
                  "i": [
                    [-27.415, 0],
                    [0, -27.415],
                    [27.415, 0],
                    [0, 27.415]
                  ],
                  "o": [
                    [27.415, 0],
                    [0, 27.415],
                    [-27.415, 0],
                    [0, -27.415]
                  ],
                  "v": [
                    [0, -49.64],
                    [49.64, 0],
                    [0, 49.64],
                    [-49.64, 0]
                  ],
                  "c": true
                },
                "ix": 2
              },
              "nm": "Path 1",
              "mn": "ADBE Vector Shape - Group",
              "hd": false
            },
            {
              "ty": "fl",
              "c": { "a": 0, "k": [0.839215695858, 0.937254905701, 0.952941179276, 1], "ix": 4 },
              "o": { "a": 0, "k": 100, "ix": 5 },
              "r": 1,
              "bm": 0,
              "nm": "Fill 1",
              "mn": "ADBE Vector Graphic - Fill",
              "hd": false
            },
            {
              "ty": "tr",
              "p": { "a": 0, "k": [0, 0], "ix": 2 },
              "a": { "a": 0, "k": [0, 0], "ix": 1 },
              "s": { "a": 0, "k": [100, 100], "ix": 3 },
              "r": { "a": 0, "k": 0, "ix": 6 },
              "o": { "a": 0, "k": 100, "ix": 7 },
              "sk": { "a": 0, "k": 0, "ix": 4 },
              "sa": { "a": 0, "k": 0, "ix": 5 },
              "nm": "Transform"
            }
          ],
          "nm": "Group 1",
          "np": 2,
          "cix": 2,
          "bm": 0,
          "ix": 1,
          "mn": "ADBE Vector Group",
          "hd": false
        }
      ],
      "ip": 0,
      "op": 96,
      "st": 0,
      "ct": 1,
      "bm": 0
    }
  ],
  "markers": []
}
